module.exports = __webpack_public_path__ + "static/media/bags4.50f093ae.jpg";